module.exports = __webpack_public_path__ + "img/2012-12-14 20.11.50.f34c53d6.jpg";